import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import { logScope, init } from 'log-scope'
import store from '@/store/store.js'

const log = logScope('bugsnag')

const bugsnagHandler = {
  apiKey: 'c36dd8bc1d61e204e2ac0e4e795730c6',
  isLocal: false
}

bugsnagHandler.init = Vue => {
  if (location.hostname === 'localhost') {
    log.danger('Is localhost, disabling bugsnag.')
    bugsnagHandler.isLocal = true
    return
  }

  window.bugsnagClient = bugsnag({
    apiKey: bugsnagHandler.apiKey,
    otherOptions: {
      appType: 'rideq_web'
    }
  })
  window.bugsnagClient.use(bugsnagVue, Vue)

  window.bugsnagClient.metaData = {}

  // Send to bugsnag on log.error
  init({
    onError: (err, data) => {
      window.bugsnagClient.notify(err, {
        metaData: data,
        user: {
          ...store.getters.customerInformation
        }
      })
    }
  })
}

bugsnagHandler.notify = (err, metaData = {}) => {
  log.danger('Bugsnag notify', metaData, err)

  if (bugsnagHandler.isLocal === true) {
    return
  }

  Object.entries(metaData).forEach(([key, value]) => {
    window.bugsnagClient.metaData[key] = value
  })

  window.bugsnagClient.notify(err)
}

export default bugsnagHandler
